<template>
  <div id="DeviceTable">
    <div class="container">
      <!-- Device List -->
      <b-table :data="deviceList" :striped="true">
        <template slot-scope="props">
          <!-- Created Date -->
          <b-table-column
            field="create_date"
            :label="$t('devices.table_header.created')"
            >{{ props.row.create_date | dateformatter }}</b-table-column
          >
          <!-- MSISDN -->
          <b-table-column
            field="msisdn"
            :label="$t('devices.table_header.msisdn')"
            >{{ props.row.msisdn }}</b-table-column
          >
          <!-- IMEI -->
          <b-table-column
            field="imei"
            :label="$t('devices.table_header.imei')"
            >{{ props.row.imei }}</b-table-column
          >
          <!-- ESN -->
          <b-table-column field="esn" :label="$t('devices.table_header.esn')">{{
            props.row.esn
          }}</b-table-column>
          <!-- Telp_Type -->
          <b-table-column
            field="telp_type"
            :label="$t('customer.detail.telp_type')"
          >
            <span v-if="props.row.telp_type === 'T'" class="tag is-info"
              >Postpaid</span
            >
            <span v-else-if="props.row.telp_type === 'P'" class="tag is-pink"
              >Prepaid</span
            >
            <span v-else class="tag is-info">Postpaid</span>
          </b-table-column>
          <!-- Actions -->
          <b-table-column
            field="Action"
            :label="$t('prospects.table_header.action')"
            centered
          >
            <b-button
              outlined
              size="is-small"
              type="is-danger"
              icon-right="delete"
              @click="confirmRemoveProspect(props.row)"
            />
          </b-table-column>
        </template>
      </b-table>
      <!-- Pagination -->
      <div style="padding: 1rem 0;">
        <b-pagination
          :total="totalItem"
          :current="currentPage"
          :per-page="itemPerPage"
          :icon-prev="'chevron-left'"
          :icon-next="'chevron-right'"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
          @change="paginationChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import AlertManager from "@/managers/AlertManager";
import DeviceApiManager from "@/apis/DeviceApiManager";

export default {
  name: "DeviceTable",
  props: ["filter"],
  data() {
    return {
      totalItem: null,
      itemPerPage: null,
      currentPage: 0,
      deviceList: []
    };
  },
  watch: {
    filter: function(val) {
      this.currentPage = 0;
      val ? this.getFilteredDeviceList(val) : this.getDeviceList();
    }
  },
  filters: {
    dateformatter: function(value) {
      if (!value) return "";
      return dayjs(value).format("DD/MM/YYYY @ HH:mm");
    }
  },
  methods: {
    paginationChange: function(selectedPage) {
      this.currentPage = selectedPage;
      this.filter
        ? this.getFilteredDeviceList(selectedPage)
        : this.getDeviceList();
    },
    confirmRemoveProspect(selectedDevice) {
      this.$buefy.dialog.confirm({
        title: "Remove Prospect Customer",
        message:
          "Are you sure you want to permanently remove device with ESN No. <b>" +
          selectedDevice.esn +
          "</b> ?",
        confirmText: "Confirm",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.removeDevice(selectedDevice._id)
      });
    },
    getDeviceList: async function() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const requestPage =
        this.currentPage - 1 >= 0 ? this.currentPage - 1 : this.currentPage;
      const devicesResult = await DeviceApiManager.requestDeviceList(
        requestPage
      );
      loadingComponent.close();

      switch (devicesResult.code) {
        case "0":
          // Setup device list data
          this.deviceList = devicesResult.data.data;
          // Setup Paginations
          // eslint-disable-next-line
          const paginationInfo = devicesResult.data.pagination;
          this.totalItem = paginationInfo.count;
          this.itemPerPage = paginationInfo.limit;
          this.currentPage = paginationInfo.page + 1;
          break;

        default:
          AlertManager.showErrorSnackbar(devicesResult.message);
          break;
      }
    },
    getFilteredDeviceList: async function(filter) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const params = {
        filter,
        page:
          this.currentPage - 1 >= 0 ? this.currentPage - 1 : this.currentPage
      };
      const devicesResult = await DeviceApiManager.requestFilteredDeviceList(
        params
      );
      loadingComponent.close();
      switch (devicesResult.code) {
        case "0":
          // Setup device list data
          this.deviceList = devicesResult.data.data;

          // Setup Paginations
          // eslint-disable-next-line
          const paginationInfo = devicesResult.data.pagination;
          this.totalItem = paginationInfo.count;
          this.itemPerPage = paginationInfo.limit;
          this.currentPage = paginationInfo.page + 1;
          break;

        default:
          AlertManager.showErrorSnackbar(devicesResult.message);
          break;
      }
    },
    removeDevice: async function(customer_id) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const removeResult = await DeviceApiManager.requestRemoveDeviceById(
        customer_id
      );
      loadingComponent.close();
      switch (removeResult.code) {
        case "0":
          this.getDeviceList();
          AlertManager.showSuccessSnackbar("Remove Device Successfully");
          break;

        default:
          AlertManager.showErrorSnackbar(removeResult.message);
          break;
      }
    }
  },
  mounted() {
    this.getDeviceList();
  }
};
</script>

<style></style>
